var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorPage',[_c('template',{slot:"Title"},[_vm._v(" No result found ")]),_c('template',{slot:"Content"},[_vm._v(" Try a new search ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }